import React, { Component } from "react"

import Stack from "@mui/material/Stack"

import { CCard, CCardImage, CCardBody, CCardTitle } from "@coreui/react"

import Typography from "@mui/material/Typography"
import EmailIcon from "@mui/icons-material/Email"
import WorkIcon from "@mui/icons-material/Work"
import TimerIcon from "@mui/icons-material/Timer"

export class UserPersonalData extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}
	render() {
		return (
			<CCard>
				<CCardImage orientation="top" src={this.props.photoURL} />

				<CCardBody>
					<CCardTitle>Datos personales</CCardTitle>

					<Typography gutterBottom variant="h5" component="div">
						{this.props.displayName}
					</Typography>
					<Stack direction="row" spacing={2}>
						<EmailIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Email: {this.props.email}
						</Typography>
					</Stack>
					<Stack direction="row" spacing={2}>
						<WorkIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Role: {this.props.role}
						</Typography>
					</Stack>
					<Stack direction="row" spacing={2}>
						<TimerIcon fontSize="small" />
						<Typography variant="body2" color="text.secondary">
							Última visita:{" "}
							{this.props.last_login.toDate().toLocaleString("es-ES")}
						</Typography>
					</Stack>
				</CCardBody>
			</CCard>
		)
	}
}

export default UserPersonalData
